import {PhoneModel} from '../../../../common/phone/entity/phone.model';
import {WithPermissionModel} from '../../../../common/permission/api/entity/withPermission.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {OfficeSummaryModel} from '../../../../office/api/model/officeSummary.model';
import {PartnerTypeSummaryModel} from './partnerTypeSummary.model';
import {AdditionalPropertyModel} from '../../../../common/additional-property/model/additionalProperty.model';
import {AccountSummary} from '../../../../../shared/model/account/accountSummary.model';
import {ExternalIdModel} from '../../../../common/externalId/api/entity/externalId.model';
import {Moment} from "moment";
import {UserSummary} from "../../../../account/modules/user/api/entity/userSummary.model";

export class PartnerSummaryModel extends WithPermissionModel{
    id: number;
    name: string;
    phone: PhoneModel;
    publicBusinessId: string;
    officePhone: PhoneModel;
    mobilePhone: PhoneModel;
    email: string;
    website: string;
    businessNumber: string;
    vatRegime: LovValueSummary;
    office: OfficeSummaryModel;
    mainPartnerPersonPersonId: number;
    mainPartnerPersonId: number;
    // mainPerson: PartnerPersonSummaryModel;
    types: PartnerTypeSummaryModel[] = [];
    // mainAddress: PartnerAddressModel;
    addresses: string[];
    additionalProperties: AdditionalPropertyModel[] = [];
    account: AccountSummary;
    externalIds: ExternalIdModel[] = [];
    hasSimilarPartners: boolean;
    note: string;
    dead: boolean;
    createdAt: Moment;
    createdBy: UserSummary;
    parentPartnerId: number;

    get mainType(): PartnerTypeSummaryModel {
        if (!this.types) {
            return undefined;
        }
        return this.types.find(value => value.main === true);
    }

    getAdditionalPropertyByKey(key: string): AdditionalPropertyModel {
        return this.additionalProperties.find(value => value.key === key);
    }

    hasAdditionalProperty(key: string): boolean {
        return !!this.getAdditionalPropertyByKey(key);
    }

    getAdditionalPropertyValueByKey(key: string): any {
        return this.getAdditionalPropertyByKey(key)?.value;
    }

    hasType(typeValue: string) {
        return this.types.findIndex(value => value.type.value === typeValue) > -1;
    }

    get tagEntityType(): string {
        return this.hasType(PartnerType.PARTNER_TYPE_PATIENT) ? 'TAG_ENTITY_TYPE_PATIENT' : undefined;
    }

    hasAtLeastOnePhone(): boolean {
        return !!this.phone || !!this.officePhone || !!this.mobilePhone;
    }
}

export enum PartnerType {
    PARTNER_TYPE_CUSTOMER = 'PARTNER_TYPE_CUSTOMER',
    PARTNER_TYPE_PATIENT = 'PARTNER_TYPE_PATIENT',
    PARTNER_TYPE_PROVIDER = 'PARTNER_TYPE_PROVIDER',
    PARTNER_TYPE_PROSPECT = 'PARTNER_TYPE_PROSPECT',
    PARTNER_TYPE_PRACTITIONER = 'PARTNER_TYPE_PRACTITIONER',
    PARTNER_TYPE_CARE_HOME = 'PARTNER_TYPE_CARE_HOME',
    PARTNER_TYPE_TUTOR = 'PARTNER_TYPE_TUTOR',
    PARTNER_TYPE_HEALTH_INSURANCE = 'PARTNER_TYPE_HEALTH_INSURANCE'
}
